export default "__VITE_ASSET__DeV1czXP__"